import type { AssistantChatConfig, AssistantWorkflow } from "./models/uwhc.models";

export const ASSISTANT_SOCKET_PATHS: Record<AssistantWorkflow, string> = {
  uwhc: "jarvis/ws-uwhc",
  "knowledge-repository": "jarvis/ws-kh-repo",
};

// Match the relay limits so rejected input stays editable instead of closing the conversation.
export const ASSISTANT_CHAT_LIMITS = {
  questionCharacters: 20_000,
  feedbackCharacters: 4_000,
  clientPayloadBytes: 64 * 1024,
  connectionTimeoutMs: 30_000,
} as const;

export const FEEDBACK_REASONS = ["Incorrect or incomplete", "Not what I asked for", "Slow or buggy", "Other"];

export const DEFAULT_ASSISTANT_CONFIG: Required<
  Pick<
    AssistantChatConfig,
    | "title"
    | "subtitle"
    | "assistantLabel"
    | "badgeLabel"
    | "systemWelcome"
    | "helperText"
    | "quickPrompts"
    | "showConnectionStatus"
    | "showResponseCount"
    | "closeButtonLabel"
  >
> = {
  title: "UWHC Assistant",
  subtitle: "Underwater Hull Cleaning & Inspection",
  assistantLabel: "UWHC Assistant",
  badgeLabel: "Provider recommendations",
  systemWelcome:
    "UWHI/C Provider Assistant activated. I can help you find Cargill-recommended vendors for Underwater Hull Inspection and Cleaning services at any port.",
  helperText: "Recommendations are generated from approved provider records and operational notes.",
  quickPrompts: [
    "Can I clean vessel in Singapore?",
    "Cleaning providers in Jebel Ali?",
    "Preferred providers in Rotterdam?",
  ],
  showConnectionStatus: true,
  showResponseCount: true,
  closeButtonLabel: "Close chat",
};
